"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TooltipPlacementType = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _omit2 = _interopRequireDefault(require("lodash/fp/omit"));

var _deviceUtils = require("../../utils/deviceUtils");

var _OverlayTrigger = _interopRequireDefault(require("../overlay/OverlayTrigger"));

var _excluded = ["allowOnTouch", "arrowProps", "children", "className", "placement", "style", "textAlignment", "tooltipStyle", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Tooltip = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _omit = (0, _omit2.default)(['popper', 'positionLeft', 'positionTop'], props),
      allowOnTouch = _omit.allowOnTouch,
      arrowProps = _omit.arrowProps,
      children = _omit.children,
      className = _omit.className,
      placement = _omit.placement,
      style = _omit.style,
      textAlignment = _omit.textAlignment,
      tooltipStyle = _omit.tooltipStyle,
      width = _omit.width,
      remainingProps = (0, _objectWithoutProperties2.default)(_omit, _excluded);

  if (!(0, _deviceUtils.isDesktop)() && !allowOnTouch) {
    // Workaround: we have to return a DOM node as otherwise the
    // react-transition library would throw an error on mobile
    // when triggering a browser reflow and accessing the node directly.
    return /*#__PURE__*/_react.default.createElement("span", {
      className: 'display-none'
    });
  }

  var wrapperClasses = (0, _classnames.default)('tooltip', tooltipStyle && "tooltip-".concat(tooltipStyle), placement, className);

  var outerStyle = _objectSpread({}, style);

  var innerClasses = (0, _classnames.default)('tooltip-inner', textAlignment && "text-".concat(textAlignment), width && "width-".concat(width));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    role: 'tooltip' // x-placement is used by the css to define how to position the arrow.
    ,
    "x-placement": placement,
    ref: ref,
    className: wrapperClasses,
    style: outerStyle,
    "data-offset": 40
  }), /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: 'tooltip-arrow'
  }, arrowProps)), /*#__PURE__*/_react.default.createElement("div", {
    className: innerClasses
  }, children));
});

Tooltip.STYLE_DEFAULT = 'default';
Tooltip.STYLE_ONBOARDING = 'onboarding';
Tooltip.defaultProps = {
  placement: Tooltip.BOTTOM,
  className: '',
  textAlignment: 'center',
  tooltipStyle: Tooltip.STYLE_DEFAULT,
  width: null,
  allowOnTouch: false
};
Tooltip.AUTO_START = _OverlayTrigger.default.AUTO_START;
Tooltip.AUTO = _OverlayTrigger.default.AUTO;
Tooltip.AUTO_END = _OverlayTrigger.default.AUTO_END;
Tooltip.TOP_START = _OverlayTrigger.default.TOP_START;
Tooltip.TOP = _OverlayTrigger.default.TOP;
Tooltip.TOP_END = _OverlayTrigger.default.TOP_END;
Tooltip.BOTTOM_START = _OverlayTrigger.default.BOTTOM_START;
Tooltip.BOTTOM = _OverlayTrigger.default.BOTTOM;
Tooltip.BOTTOM_END = _OverlayTrigger.default.BOTTOM_END;
Tooltip.RIGHT_START = _OverlayTrigger.default.RIGHT_START;
Tooltip.RIGHT = _OverlayTrigger.default.RIGHT;
Tooltip.RIGHT_END = _OverlayTrigger.default.RIGHT_END;
Tooltip.LEFT_START = _OverlayTrigger.default.LEFT_START;
Tooltip.LEFT = _OverlayTrigger.default.LEFT;
Tooltip.LEFT_END = _OverlayTrigger.default.LEFT_END;

var TooltipPlacementType = _propTypes.default.oneOf([Tooltip.AUTO_START, Tooltip.AUTO, Tooltip.AUTO_END, Tooltip.TOP_START, Tooltip.TOP, Tooltip.TOP_END, Tooltip.BOTTOM_START, Tooltip.BOTTOM, Tooltip.BOTTOM_END, Tooltip.RIGHT_START, Tooltip.RIGHT, Tooltip.RIGHT_END, Tooltip.LEFT_START, Tooltip.LEFT, Tooltip.LEFT_END]);

exports.TooltipPlacementType = TooltipPlacementType;
Tooltip.propTypes = {
  placement: TooltipPlacementType,
  className: _propTypes.default.string,
  allowOnTouch: _propTypes.default.bool,
  tooltipStyle: _propTypes.default.oneOf([Tooltip.STYLE_DEFAULT, Tooltip.STYLE_ONBOARDING]),
  textAlignment: _propTypes.default.oneOf(['left', 'center', 'right']),
  width: _propTypes.default.oneOf(['auto', 100, 150, 200, 250, 300, 350, 400, 450, 500])
};
var _default = Tooltip;
exports.default = _default;